var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.rows),function(row){return _c('div',{staticClass:"grid__tr"},[_c('div',{staticClass:"grid__row-header",style:([_vm.style, row.style])},[_vm._v(_vm._s(_vm.getText_(row)))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }